export enum Color {
    TEXT_DARK = "--text-dark",
    TEXT_LIGHT = "--text-light",
    WHITE = "--white",
    PRIMARY = "--primary",
    PRIMARY_400 = "--primary-400",
    PIRMARY_300 = "--primary-300",
    PRIMARY_BG = "--primary-bg",
    SECONDARY = "--secondary",
    SECONDARY_400 = "--secondary-400",
    SECONDARY_300 = "--secondary-300",
    SECONDARY_BG = "--secondary-bg",
    ACCENT = "--accent",
    ACCENT_400 = "--accent-400",
    ACCENT_300 = "--accent-300",
    ACCENT_BG = "--accent-bg",
    ACCENT_2 = "--accent-2",
    ACCENT_2_400 = "--accent-2-400",
    ACCENT_2_300 = "--accent-2-300",
    ACCENT_2_BG = "--accent-2-bg",
    GREY = "--grey",
    DEFAULT = "default",
}
